import { timer, Observable } from 'rxjs';
import { take, map } from 'rxjs/operators';

export function getCountDown(countSeconds: number): Observable<number> {
  const period = 1000;
  return timer(0, period).pipe(
    take(countSeconds),
    map((number) => {
      return countSeconds - (number + 1);
    }),
  );
}
